import React from 'react';
import {
  Box,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import './FormResponsesList.css';

const COLUMNS = [
  'Submission',
  'Submitted At',
  'Response ID',
  'Payment',
  'KYC',
  'eSign (MITC)',
  'Actions',
];

export const FormResponsesSkeleton: React.FC<{ rows?: number }> = ({
  rows = 6,
}) => (
  <Box className="admin-page responses-page">
    <Box className="responses-header">
      <Skeleton variant="rounded" width={36} height={36} />
      <Box>
        <Skeleton variant="text" width={168} height={28} />
        <Skeleton variant="text" width={124} height={18} />
      </Box>
    </Box>

    <Box className="admin-card">
      <TableContainer className="responses-table-scroll">
        <Table className="responses-table">
          <TableHead>
            <TableRow className="admin-table-head-row">
              {COLUMNS.map((column, index) => (
                <TableCell
                  key={column}
                  align={index === COLUMNS.length - 1 ? 'right' : 'left'}
                >
                  {column}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {Array.from({ length: rows }).map((_, row) => (
              <TableRow className="admin-table-row" key={row}>
                <TableCell>
                  <Skeleton variant="text" width={34} height={20} />
                </TableCell>
                <TableCell>
                  <Skeleton variant="text" width={128} height={20} />
                </TableCell>
                <TableCell>
                  <Skeleton variant="rounded" width={168} height={24} />
                </TableCell>
                <TableCell align="center">
                  <Skeleton variant="rounded" width={72} height={20} sx={{ mx: 'auto' }} />
                </TableCell>
                <TableCell align="center">
                  <Skeleton variant="rounded" width={72} height={20} sx={{ mx: 'auto' }} />
                </TableCell>
                <TableCell align="center">
                  <Skeleton variant="rounded" width={72} height={20} sx={{ mx: 'auto' }} />
                </TableCell>
                <TableCell align="right">
                  <Skeleton variant="rounded" width={34} height={34} sx={{ ml: 'auto' }} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  </Box>
);
